
import store from '@/store';
import {defineComponent} from 'vue';
import UserInfoDto from "@/dto/UserInfoDto";
import {Modal} from "bootstrap";
import PasswordUtils from "@/utils/PasswordUtils";
import LoadingUtils from "@/utils/LoadingUtils";
import TWebKaiinJoho from "@/entity/TWebKaiinJoho";
import Dialog from "@/utils/Dialog";
import ValidateUtils from "@/utils/ValidateUtils";

export default defineComponent({
  name: 'LoginView',
  components: {},
  created() {
    let eParam = this.$route.query.e
    if(!eParam){
      eParam = ''
    }
    this.tParam = this.$route.query.t as string
    if(!this.tParam){
      this.tParam = ''
    }
    let nParam = this.$route.query.n as string
    if(!nParam){
      nParam = ''
    }

    this.axios.get('/eDecode',{params:{e:eParam}}).then(async (res) => {
      if(nParam){
        const userName =(await this.axios.get('/eDecode',{params:{e:nParam}})).data as string
        if(userName){
          this.userName = userName
          this.userId = res.data;
        }else{
          if(nParam){
            this.invalidUrl = true;
          }
        }
      }else{
        this.userId = res.data;
      }
      if (this.userId) {
        //logService.info("Webユーザー登録", "初期表示", mailAddress);
        //logService.info(requestBody.get("functionName"), requestBody.get("action"), requestBody.get("message"));
        this.axios.post('/logInfo'
            , {functionName: 'Webユーザー登録', action: '初期表示', message: this.userId}
            ,{headers:{'Content-Type': 'application/json; charset=UTF-8'}}).then((res) => {
          //
        }).catch()
        this.timeout = (await this.axios.get('/isTimeout', {params: {t: this.tParam}})).data as boolean
        console.log('timeout:' + this.timeout)
        if(!this.timeout){
          this.axios.get('/isWebKaiinRegister', {params: {mailAddress: this.userId}}).then((res) => {
            const exits = res.data as boolean;
            this.alreadyRegistered = exits
            this.ready = true
          }).catch()
        }else{
          this.ready = true
        }
      } else {
        if(eParam){
          this.invalidUrl = true;
        }
        this.axios.post('/logError', {functionName: 'Webユーザー登録', action: '初期表示', message: '複合化に失敗しました。'}).then((res) => {
          //
        }).catch()
        this.ready = true
      }

    }).catch()
  },
  mounted() {
    console.log('mounted');
    //(this.$refs.confirmModal as HTMLElement).addEventListener('hide.bs.modal', this.onHide);
    //(this.$refs.testButton as HTMLButtonElement).focus();
    this.$nextTick(() => {
      console.log('mo>>>>>>>>>>>>>unted');
      setTimeout(() => { // わずかな遅延 (例: 50ms)
        console.log('focusing on input');
        if (this.userId) {
          (this.$refs.inputPassword as HTMLInputElement)?.focus();
          console.log('userId is not empty, focusing on password input');
        } else {
          (this.$refs.inputUserId as HTMLInputElement)?.focus();
          console.log('userId is empty, focusing on password input');
        }
      }, 500)
    });
  },
  methods:{
    goExam(){
      this.$router.push('/exam')
    },
    showKojinModal(){
      this.kojinModal?.show()
    },
    hideKojinModal(){
      this.kojinModal?.hide()
    },
    userIdOperation(){
      this.maiAddressMessage = ''
      if(this.userId){
        if(ValidateUtils.isEMailAddress(this.userId)){
          this.axios.post('/existsMXRecordFroEmail', { mailAddress: this.userId } ).then(res => {
            const v = res.data as { [key: string]: string | boolean };
            if(v.mailAddress===this.userId){
              if(!(v.result as boolean)){
                this.maiAddressMessage = 'メールアドレスのドメインが正しくありません。'
                this.userIdValid = false
              }else{
                /*
                          this.axios.get('/isWebKaiinRegister', {params: {mailAddress: this.userId}}).then((res) => {
            const exits = res.data as boolean;
            this.alreadyRegistered = exits
            this.ready = true
          }).catch()
                 */
                this.axios.get('/isWebKaiinRegister', {params: {mailAddress:  this.userId}}).then((res) => {
                  this.userIdValid = !res.data as boolean;
                  if(!this.userIdValid){
                    this.maiAddressMessage = 'このメールアドレスは既に登録されています。'
                  }
                }).catch()
              }
            }else{
              console.log('追い越し')
            }
          }).catch(e => {
            console.log(e)
            this.userIdValid = false
          })
        }else{
          this.maiAddressMessage = 'メールアドレスが正しくありません。'
          this.userIdValid = false
        }
      }else{
        this.userIdValid = false
      }
    },
    async register() {
      this.timeout = this.tParam ? (await this.axios.get('/isTimeout', {params: {t: this.tParam}})).data as boolean : false
      if(!this.timeout){
        Dialog.confirm('Webユーザー登録をされた場合は、健診結果をWebでご覧いただくことに同意されたものとみなします。よろしいですか？').then((ok: boolean)=>{
          if (ok) {
            LoadingUtils.start();
            setTimeout(() => {
              (this.$refs.registerButton as any).focus();
            }, 0)
            //webKaiinRegister
            console.log(new Date())
            this.axios.post('/webKaiinRegister', {
              webKaiinLoginId: this.userId,
              webKaiinMailAddress: this.userId,
              webKaiinPassword: this.password,
              webKaiinName: this.userName,
              createDatetime: new Date()
            } as TWebKaiinJoho).then((res) => {
              LoadingUtils.end()
              const date = (res.data as TWebKaiinJoho).createDatetime
              console.log('cred = ' + typeof date)
              console.log('cred = ' + typeof new Date(date))
              if (res.data) {
                this.registered = true
                this.alreadyRegistered = false;
              } else {
                this.registered = false
                this.alreadyRegistered = true
              }
            }).catch((e) => {
              //
            })
          }
        })
      }
    }
  },
  data(){
    return {
      loginPath: process.env.VUE_APP_PUBLIC_PATH,
      ready: false,
      userId: '',
      userName: '',
      password: '' as string,
      confirmPassword: '',
      showMessage: false,
      showPassword: false,
      kojinModal: null as Modal|null,
      alreadyRegistered: false,
      registered: false,
      timeout: false,
      tParam : '',
      kojinFlg: false,
      maiAddressMessage: '',
      userIdValid: true,
      invalidUrl: false
    }
  },
  computed:{
    canRegister(): boolean{
      return (this.userIdValid && !!this.userId) && (this.validPassword) && (this.password === this.confirmPassword) && (this.userName!==null && this.userName!==undefined && this.userName.length>0 && !this.registered)
    },
    validPassword():boolean{
      return PasswordUtils.validPassword(this.password)
    },
    /**
     * 処理中(store)
     */
    loading: {
      get(): boolean {
        return store.getters.loading
      },
      set(loading: boolean) {
        store.commit('setLoading', loading)
      }
    },
    /**
     * ユーザー情報(store)
     */
    userInfo: {
      get(): UserInfoDto|null {
        return store.getters.userInfo
      },
      set(userInfo: UserInfoDto|null) {
        store.commit('setUserInfo', userInfo)
      }
    },
  }
});
